import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=307d4480"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
import style0 from "./Loader.vue?vue&type=style&index=0&id=307d4480&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('307d4480')) {
      api.createRecord('307d4480', component.options)
    } else {
      api.reload('307d4480', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=307d4480", function () {
      api.rerender('307d4480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/lib/components/Loader.vue"
export default component.exports